import { useEffect } from 'react';

const pdfPath = `${process.env.PUBLIC_URL}/presentations/restaurant-promotions-ro.pdf`;

const RestaurantPromotionsPresentation = () => {
    useEffect(() => {
        window.location.replace(pdfPath);
    }, []);

    return (
        <p>
            Opening presentation PDF...
            {' '}
            <a href={pdfPath}>Open manually</a>
        </p>
    );
};

export default RestaurantPromotionsPresentation;
